module.exports = __webpack_public_path__ + "static/media/cordobabaitcast.28000f66.png";